import { Upload, Trash2 } from "lucide-react";
import React, { useState, useEffect } from "react";

const FilesUpload = ({
  register,
  name,
  errors,
  setValue,
  watch,
  label,
  accept,
}) => {
  const [files, setFiles] = useState([]);

  const watchedFiles = watch(name) || [];

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(2), // size in KB
      type: file.type,
    }));

    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    setValue(name, [...watchedFiles, ...e.target.files]); // Update the files in React Hook Form
  };

  const handleDelete = (fileIndex) => {
    const updatedFiles = files.filter((_, index) => index !== fileIndex);
    setFiles(updatedFiles);

    const updatedWatchedFiles = watchedFiles.filter(
      (_, index) => index !== fileIndex
    );
    setValue(name, updatedWatchedFiles); // Update the files in React Hook Form
  };

  useEffect(() => {
    if (watchedFiles) {
      setFiles(
        Array.from(watchedFiles).map((file) => ({
          name: file.name,
          size: (file.size / 1024).toFixed(2),
          type: file.type,
        }))
      );
    }
  }, [watchedFiles]);

  return (
    <div className="">
      <div className="flex justify-start items-center gap-2 text-center mb-1.5">
        <label
          className=" bg-primary/80 text-text-gen p-1 rounded-md cursor-pointer hover:bg-primary"
          htmlFor={name}
        >
          <Upload />
        </label>
        <label className="text-text-1/90 font-medium">{label}</label>
        <input
          className="hidden"
          id={name}
          type="file"
          accept={accept}
          multiple
          {...register(name)}
          onChange={handleFileChange}
        />
      </div>

      {errors && (
        <p className="text-red-400 text-xs text-wrap mb-2">{errors.message}</p>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th className="p-1 py-2 bg-gray-600 text-text-gen ">Filename</th>
              <th className="p-1 py-2 bg-gray-600 text-text-gen text-center ">
                Size (KB)
              </th>
              <th className="p-1 py-2 bg-gray-600 text-text-gen text-center">
                Type
              </th>
              <th className="p-1 py-2 bg-gray-600 text-text-gen text-center">
                Action
              </th>
              {/* Changed from Status to Action */}
            </tr>
          </thead>
          {files.length > 0 && (
            <tbody>
              {files.map((file, index) => (
                <tr key={index}>
                  <td className="p-1">{file.name}</td>
                  <td className="p-1 text-center">{file.size}</td>
                  <td className="p-1 text-center">{file.type}</td>
                  <td className="p-1 text-center">
                    {/* Delete button */}
                    <button
                      type="button"
                      onClick={() => handleDelete(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default FilesUpload;
